import type { CheckboxState } from '../../models/checkbox.models';
import {
  featureFlagDefinition,
  type FeatureFlagDefinition,
  type FeatureFlagName,
} from './feature-flag-definition.consts';

export type FeatureFlag = Partial<Record<FeatureFlagName, boolean>>;

export type FeatureFlagItem = {
  id: FeatureFlagName;
  checkboxState: CheckboxState;
} & Pick<FeatureFlagDefinition, 'displayName' | 'defaultState'>;

export const isFeatureFlagKey = (key: string): key is FeatureFlagName =>
  key in featureFlagDefinition;
